import { UseFormGetValues } from 'react-hook-form'
import { Alert } from '../../../../../components/alerts/Alert'
import { TAutorizacionForm } from '../../../models/autorizacionForm.type'

type Props = {
  getValues: UseFormGetValues<TAutorizacionForm>
}
export const AlertDuracion = ({ getValues }: Props) => {
  // Mensajeria contextual para guiar al usuario cuando faltan campos
  // necesarios para calcular la fecha de vencimiento en modo "duracion".
  return (
    <div className='  col-8 '>
      <Alert
        color='dark'
        dismissible={true}
        mensaje={`${
          !getValues('fechaEmision') &&
          (!getValues('unidadDuracion') || !getValues('cantidadDuracion'))
            ? 'Selecciona una fecha de emisión y duración'
            : getValues('fechaEmision') &&
              (!getValues('unidadDuracion') || !getValues('cantidadDuracion'))
            ? 'Selecciona la duración'
            : !getValues('fechaEmision') &&
              (getValues('unidadDuracion') || getValues('cantidadDuracion'))
            ? 'Selecciona una fecha de emisión'
            : ''
        }.`}
      />
    </div>
  )
}
